import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { IoMdArrowBack, IoIosCheckmarkCircle } from "react-icons/io";
import toast from "react-hot-toast";
import { changePhone } from "../../redux/ApiSlice/AccountSettingSlice";

const AccountPhoneNumber = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { User_profile } = useSelector((state) => state.AccountProfile);
    const [newPhone, setNewPhone] = useState("");
    const [loading, setLoading] = useState(false);

    const currentPhone = User_profile?.phone || null;

    const US_COUNTRY_CODE = "+1";

    const formatPhoneDisplay = (digits) => {
        if (digits.length <= 3) return digits;
        if (digits.length <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
        return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
    };

    const handlePhoneChange = (e) => {
        const digits = e.target.value.replace(/\D/g, "").slice(0, 10);
        setNewPhone(digits);
    };

    return (
        <div className="bg-white dark:bg-[#1E1D21]">
            <div className="sticky top-0 z-50">
                <div className="relative flex items-center justify-center h-12 bg-[#BDE6FF] rounded-b-xl px-2">
                    <IoMdArrowBack
                        onClick={() => navigate("/settings/account/details")}
                        className="absolute left-2 top-1/2 transition-transform -translate-y-1/2 text-[24px] text-black cursor-pointer"
                    />
                    <p className="text-center font-bold text-[16px] text-black flex-grow">Phone Number</p>
                </div>
            </div>

            <form
                onSubmit={async (e) => {
                    e.preventDefault();

                    if (newPhone.length !== 10) {
                        toast.error("Please enter a valid 10-digit phone number");
                        return;
                    }

                    const fullPhone = `${US_COUNTRY_CODE}${newPhone}`;

                    setLoading(true);
                    try {
                        const response = await dispatch(changePhone({ new_phone: fullPhone })).unwrap();
                        const message = response?.message || "OTP sent successfully!";
                        toast.success(message);
                        navigate("/settings/account/verify-phone", { state: { newPhone: fullPhone } });
                    } catch (error) {
                        const errorMessage =
                            (Array.isArray(error?.new_phone) && error.new_phone[0]) ||
                            error?.new_phone ||
                            error?.detail ||
                            error?.error ||
                            error?.message ||
                            "Failed to send OTP. Please try again.";
                        toast.error(errorMessage);
                    } finally {
                        setLoading(false);
                    }
                }}
                className="px-3 flex flex-col justify-between h-[calc(80vh-60px)]"
            >
                <div className="flex flex-col pt-5">
                    <p className="text-[14px] text-black dark:text-white font-bold">Phone Number</p>
                    <p className="text-[12px] text-justify text-black dark:text-white pt-1">
                        This is the phone number linked to your Chaa Chingg account.
                        You can add or update it at any time here.
                    </p>

                    <div className="mt-5 border-2 border-[#BDE6FF] dark:border-gray-800/50 rounded-lg">
                        {currentPhone && (
                            <div className="flex items-center justify-between px-5 py-4 border-b-2 border-[#BDE6FF] dark:border-gray-800/50">
                                <div className="flex flex-col">
                                    <p className="text-[12px] text-black dark:text-white font-bold">Verified phone number</p>
                                    <p className="w-full text-[12px] text-black dark:text-white">
                                        {currentPhone}
                                    </p>
                                </div>
                                <IoIosCheckmarkCircle className="text-[22px] text-[#4cb6f9]" />
                            </div>
                        )}
                        <div className="px-5 py-4">
                            <p className="text-[12px] text-black dark:text-white font-bold">
                                {currentPhone ? "Enter new phone number" : "Enter phone number"}
                            </p>
                            <div className="flex items-center gap-2 mt-1">
                                <span className="text-[12px] text-black dark:text-white font-bold select-none">+1</span>
                                <input
                                    type="tel"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    placeholder="234-567-8901"
                                    value={formatPhoneDisplay(newPhone)}
                                    onChange={handlePhoneChange}
                                    className="flex-1 text-[12px] bg-white dark:bg-[#1E1D21] text-black dark:text-white outline-none"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <button
                    type="submit"
                    disabled={loading || newPhone.length !== 10}
                    className={`text-[13px] w-full py-3 rounded-lg font-bold ${loading || newPhone.length !== 10
                        ? "bg-[#BDE6FF] text-black cursor-not-allowed"
                        : "bg-[#BDE6FF] text-black cursor-pointer"
                        }`}
                >
                    {loading ? "Sending..." : "Send verification SMS"}
                </button>
            </form>
        </div>
    );
};

export default AccountPhoneNumber;
